var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParachuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98667 11C9.31987 9.6668 10.6536 9.0002 11.9868 9.0002C13.32 9.0002 14.6538 9.6668 15.987 11C17.5424 9.6668 18.7095 9.0002 19.4866 9.0002C20.2643 9.0002 21.4314 9.6668 22.9868 11C22.9868 4.9247 18.0621 0 11.9868 0C5.91152 0 0.986816 4.9247 0.986816 11C2.54222 9.6668 3.70932 9.0002 4.48702 9.0002C5.26472 9.0002 6.43127 9.6668 7.98667 11Z",
    fill: "#1A74EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92432 11L11.9868 22M11.9868 22L7.79932 9.05884M11.9868 22L15.9243 9.05884M11.9868 22L22.0493 11",
    stroke: "#1A74EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParachuteIcon);
export default __webpack_public_path__ + "static/media/parachute-icon.685c3f8637cfa3fbb1edc831f890b428.svg";
export { ForwardRef as ReactComponent };